export enum Ruleset {
  TRACER = 'TRACER',
  COMPLIANCE = 'COMPLIANCE',
  VULNERABILITY = 'VULNERABILITY',
}
